// extracted by mini-css-extract-plugin
module.exports = {"StorePage":"StorePage_StorePage__9O-Vh","LearnMore":"StorePage_LearnMore__3pXtq","BackgroundCard":"StorePage_BackgroundCard__3X1jh"};